<template>
  <div>
    <div v-if="loading" class="text-center">
      <div class="spinner-border text-center" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="text-center">
        <img class="mb-3 logo" :src="logo">
      </div>
      <div class="user-info">
        <h2>Payment process</h2>
        <p>
          <strong>Client Name:</strong> {{info.clientFirstName}} {{info.clientLastName}}<br>
          <strong>Reservation:</strong> #{{info.reservationId}}<br>
          <strong>Total to pay:</strong> ${{info.total}} {{info.currency}}
        </p>
      </div>
    </div>
    <div :class="loading?'d-none':''">
      <b-collapse visible id='ppplus-container'>
        <div id="ppplus"></div>
      </b-collapse>
      <div v-if="false" class="">
        <div class="alert alert-danger" role="alert"></div>
      </div>
      <div class="text-center" >
        <button @click="runPPP()" class="btn btn-primary btn-block">PAY</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PaypalPlus',
  props: {
  },
  data: () => {
    return {
      loading: true,
      ppp: null,
      info: {}
    }
  },
  mounted() {
    this.$http.get('payments/pcard', {params: {token: this.$route.query.token}})
    .then((res) => {
      this.loading = false
      const body = res.body;
      if (!body || !body.approvalUrl) {
        throw new Error();
      }
      const data = {
        "approvalUrl": body.approvalUrl,
        "payerEmail": body.clientEmail,
        "payerFirstName": body.clientFirstName,
        "payerLastName": body.clientLastName,
        "payerTaxId": "",
        "disallowRememberedCards":true,
        "placeholder": "ppplus",
        "mode": body.mode,
      };
      this.info = res.body;
      this.ppp = window.PAYPAL.apps.PPP(data);
      this.setEvents();
    }).catch(() => {
      this.$router.push('error');
    });
  },
  computed: {
    ...mapState(['hasSetting', 'settings']),
    logo() {
      if (this.hasSetting) {
        return this.settings.logo;
      }
      return 'https://api.btransfer.mx/uploads/btransfer-logo.png';
    }
  },
  methods: {
    runPPP() {
      this.ppp.doContinue();
    },
    setEvents() {
      if (window.addEventListener) {
        window.addEventListener("message", this.messageListener, false);
        console.log("addEventListener successful", "debug");
      } else if (window.attachEvent) {
          window.attachEvent("onmessage", this.messageListener);
          console.log("attachEvent successful", "debug");
      } else {
          console.log("Could not attach message listener", "debug");
          throw new Error("Can't attach message listener");
      }
    },
    messageListener(event) {
      if (!event.data) {
        return ;
      }
      var data;
      try{
        data = JSON.parse(event.data);
      }catch(a) {
        return ;
      }
      if (data.action === "checkout") {
        this.checkout(data.result.payer.payer_info);
      }
    },
    checkout(payer) {
      this.loading = true
      this.$http.get('payments/execute-payment', {
        params: {token: this.$route.query.token, payerId: payer.payer_id}
      }).then((res) => {
        if (res.body && res.body.success) {
          this.$router.push('success');
        }
      }).catch(() => {
        this.$router.push('error');
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo{
		max-width: 200px;
  }

	.border{
		width: 100%;
		margin: 0 auto;
    border: 1px solid rgb(37, 36, 36);
    border-radius: 10px;
	}

  .user-info{
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .user-item{
    width: auto;
  }
</style>
<style>
  #ppplus iframe{
    width: 100% !important;
  }
</style>
